import styled from "styled-components";
import { lighten, darken } from "polished";
import theme from "../style/theme";

const $disabled1 = darken(0.14, theme.c.light);
const $disabled2 = lighten(0.18, theme.c.pale);
const $disabled3 = darken(0.1, theme.c.pale);

export const Icon = styled.div`
    background-color: ${$disabled2};
    border: 4px solid ${$disabled1};
    transition: 300ms;
    .color-1-fill {
        fill: ${$disabled1};
    }

    .color-2-stroke {
        stroke: ${$disabled3};
    }

    .color-2-fill {
        fill: ${$disabled3};
    }
    display: inline-block;
    border-radius: 50px;
    overflow: hidden;
    flex-shrink: 0;

    svg {
        display: block;
        * {
            transition: 300ms;
        }
    }

    &.ActiveIcon {
        background-color: ${theme.c.active};
        border: 4px solid ${theme.c.boost};
        .color-1-fill {
            fill: ${theme.c.info};
        }

        .color-2-stroke {
            stroke: ${theme.c.black};
        }

        .color-2-fill {
            fill: ${theme.c.black};
        }
    }

    &.CompletedIcon {
        background-color: ${theme.c.info};
        border: 4px solid ${darken(0.1, theme.c.info)};
        .color-1-fill {
            fill: ${lighten(0.3, theme.c.info)};
        }

        .color-2-stroke {
            stroke: ${darken(0.2, theme.c.info)};
        }

        .color-2-fill {
            fill: ${darken(0.2, theme.c.info)};
        }
    }
`;
/**
 * The wordmark as a mask over a coloured box, rather than 3.5 kB of path data inlined
 * into every page the server renders. As a file the browser fetches it once and keeps
 * it; a mask rather than an img because the mark takes its colour from what it sits on -
 * the nav paints it with the theme's colour, which an img could not follow. The mask is
 * sized to the box, so a caller that wants a bigger logo only sets width and height.
 */
export const LogoMark = styled.div`
    width: 188px;
    height: 40px;
    background-color: currentColor;
    -webkit-mask: url("/images/logo.svg") no-repeat center / 100% 100%;
    mask: url("/images/logo.svg") no-repeat center / 100% 100%;
`;

export const LogoWrapper = styled.div`
    position: relative;
    width: 188px;
    height: 40px;
`;

/**
 * The slogan is text, not a graphic: it is translated, so it cannot travel in the file.
 * Placed where the svg's own text element used to sit - the mark's box is 40 high and
 * the letters end at 28, which leaves the strip this writes into.
 */
export const LogoSlogen = styled.div<{ $centered: boolean }>`
    position: absolute;
    left: 0;
    right: 0;
    top: 26px;
    font-size: 12px;
    font-weight: 300;
    line-height: 12px;
    white-space: nowrap;
    text-align: ${p => (p.$centered ? "center" : "left")};
    // The svg text was centred on x=97 of a box that starts at x=2, which is one pixel
    // right of the box's own centre.
    padding-left: ${p => (p.$centered ? 2 : 32)}px;
`;
